import { render } from "./PretreatmentTable.vue?vue&type=template&id=0226e5b6&scoped=true"
import script from "./PretreatmentTable.vue?vue&type=script&lang=js"
export * from "./PretreatmentTable.vue?vue&type=script&lang=js"

import "./PretreatmentTable.vue?vue&type=style&index=0&id=0226e5b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0226e5b6"]])

export default __exports__